import styled from "styled-components"

import { formatPriceByLocale } from "utils/utils"

export default function TotalPriceInfo({ totalPrice }) {
  return (
    <Section>
      <GridItem>
        <Label>총 결제 금액</Label>
        <Price>{totalPrice && formatPriceByLocale("ko", totalPrice)}원</Price>
      </GridItem>
    </Section>
  )
}

const Section = styled.div`
  padding-top: calc(100vw * (21 / 375));
  padding-bottom: calc(100vw * (27 / 375));
`

const GridItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const Label = styled.span`
  font-size: calc(100vw * (16 / 375));
  font-weight: 500;
  line-height: calc(100vw * (19 / 375));
  color: #121212;
`

const Price = styled.span`
  font-size: calc(100vw * (20 / 375));
  font-weight: 700;
  line-height: calc(100vw * (24 / 375));
  color: #121212;
`
